import { render, staticRenderFns } from "./PriceTableRow.vue?vue&type=template&id=d6240d68&scoped=true&lang=pug"
import script from "./PriceTableRow.vue?vue&type=script&lang=js"
export * from "./PriceTableRow.vue?vue&type=script&lang=js"
import style0 from "./PriceTableRow.vue?vue&type=style&index=0&id=d6240d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6240d68",
  null
  
)

export default component.exports